import React from "react";

// components

import CardStats from "../Cards/CardStats"

export default function HeaderStats() {
  return (
    <>
      {/* Header */}
      <div className="bg-[#0471a3] md:pt-32 pb-20 pt-12">
        {/* <div className="px-4 md:px-10 mx-auto w-full">
          
        </div> */}
      </div>
    </>
  );
}
